/*
* Created on Oct 29, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

import React, {createContext, useContext, useEffect, useState} from 'react';
import CookiesManagerComponent from "../component/cookies/CookiesManagerComponent";
import CookiesSettingsComponent from "../component/cookies/CookiesSettingsComponent";
import {useAuthService} from "../hook/AuthServiceHook";
import useEnableCookies from '../hook/CookiesSettingsHook';


const CookiesSettingContext = createContext(null);
export const useCookiesSettings = () => useContext(CookiesSettingContext);


const CookiesSettingProvider = ({children}) => {
    const {AUTHAPI} = useAuthService();
    const [showManager, setShowManager] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const {setACSetting, setFCSetting} = useEnableCookies();
    const [cookieSettings, setCookieSettings] = useState({});

    const get_cookies_settings = () => {
        const cookie_settings = AUTHAPI.get_cookies_settings();
        setACSetting(cookie_settings.AC);
        setFCSetting(cookie_settings.FC);
        setShowManager(!cookie_settings.is_cookies_set);
        setCookieSettings(cookie_settings);
        return cookie_settings;
    };

    useEffect(()=>{
        get_cookies_settings();
    }, []);


    return (
        <CookiesSettingContext.Provider value={{showManager, setShowManager, showSettings, setShowSettings, get_cookies_settings, cookieSettings}} >
            {children}
            <>
                <CookiesManagerComponent showManager={showManager} setShowManager={setShowManager} setShowDialog={setShowSettings} />
                {showSettings && <CookiesSettingsComponent showDialog={showSettings} setShowDialog={setShowSettings} setShowManager={setShowManager} />}
            </>
        </CookiesSettingContext.Provider>
    );
}

export default CookiesSettingProvider